import clsx from "clsx";
import * as React from "react";

interface SkeletonProps extends React.ComponentPropsWithoutRef<"div"> {
  height?: React.CSSProperties["height"];
  circle?: boolean;
  width?: React.CSSProperties["width"];
}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (props, ref) => {
    const { height, circle, width, style, className, ...rest } = props;

    const styles: React.CSSProperties = {
      borderRadius: circle ? "50%" : 4,
      height: height ?? 8,
      width: circle ? height : width,
    };
    return (
      <div
        className={clsx("ox-reset ox-Skeleton", className)}
        aria-hidden
        tabIndex={-1}
        ref={ref}
        style={{
          ...styles,
          ...style,
        }}
        {...rest}
      />
    );
  },
);

Skeleton.displayName = "Skeleton";
export { Skeleton };
export type { SkeletonProps };
